import * as _ from 'lodash';
import React from 'react';

import { Product } from '../../../interfaces';
import { useIntArraySearchParam, useIngredientGroups } from '../../../hooks';

interface Props {
  product: Product;
}

export default function ActiveIngredientTags(props: Props) {
  const {
    product: { ingredients },
  } = props;
  const igs = useIngredientGroups();
  const [, excludeActiveIngredientsActions] = useIntArraySearchParam(
    '-ingredientGroups'
  );

  const igLookup = _.keyBy(igs, 'groupId');
  const groupIds = Array.from(
    new Set(
      ingredients.map(({ groupId }) => groupId).filter((groupId) => groupId)
    )
  );
  const groups = groupIds
    .map((groupId) => igLookup[groupId])
    .filter((group) => group);

  return (
    <div className="field is-grouped is-grouped-multiline">
      {groups.map(({ id, groupId, priming }) => (
        <div className="control" key={priming}>
          <div className="tags has-addons">
            <span className="tag is-primary" key={id}>
              {priming}
            </span>
            <a
              className="tag is-delete"
              onClick={() => excludeActiveIngredientsActions.add(groupId)}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
